// extracted by mini-css-extract-plugin
export default {"link":"result_link__GaR5m","open":"result_open__A5dpY","name":"result_name__4hSuE"};